import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=ca7b7e74&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b7e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7b7e74')) {
      api.createRecord('ca7b7e74', component.options)
    } else {
      api.reload('ca7b7e74', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=ca7b7e74&scoped=true&", function () {
      api.rerender('ca7b7e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xvs2Q3GelPB1/JS/comp/Voucher-Unit.vue"
export default component.exports